import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
export const Portal = ({ children, targetElementId }) => {
    const mount = useRef(document.createElement("div"));
    useEffect(() => {
        const portalParent = targetElementId ? document.getElementById(targetElementId) || document.body : document.body;
        const node = mount.current;
        if (node)
            portalParent.appendChild(node);
        return () => {
            if (portalParent.contains(node))
                portalParent.removeChild(node);
        };
    }, [mount, targetElementId]);
    return createPortal(children, mount.current);
};
